import React from "react";
import { groupByDate } from "utils/helpers";
import { map } from "lodash";

const List = ({ data = [], render }) => {
  const groupedItems = groupByDate(data);
  return (
    <div className="transaction__list">
      {map(Object.entries(groupedItems), render)}
    </div>
  );
};

export default List;
